import BaseAPI from '../api'
const path = 'employees'
export interface EmployeesInterface {
    idEmployee?: number
    employeeFirstname?: string
    employeeLastname?: string
    email?: string
    password?: string
    idDepartment?: number
    idRole?: number
    idPosition?: number
    fax?: string
    tel?: string
    permission?: any
    employeeStatus?: string
    page?: number;
    limit?: number;
    keyword?: string;
    sortBy?: string;
    sortType?: string;
}

export default class EmployeesApi extends BaseAPI {

    static getEmployees(props: EmployeesInterface): Promise<any> {
        return this.api.get(`${path}`, { params: { ...props } })
            .then((res) => res)
    }
    static postEmployees(props: EmployeesInterface): Promise<any> {
        return this.api.post(`${path}`, { ...props }, {})
            .then((res) => res)
    }
    static patchEmployees(idEmployee: number, props: EmployeesInterface): Promise<any> {
        return this.api.patch(`${path}/${idEmployee}`, { ...props }, {})
            .then((res) => res)
    }
    static getEmployee(idEmployee: number): Promise<any> {
        return this.api.get(`${path}/${idEmployee}`, {})
            .then((res) => res)
    }
}
